import { IconProps } from 'types/icon.type'

// TODO: Replace icon with the open source one

export const EditIcon = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Edit Pencil Icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6577 2.2945C17.327 1.62529 18.2349 1.24939 19.1814 1.24951C20.1279 1.24963 21.0356 1.62575 21.7048 2.29513C22.374 2.96451 22.7499 3.87231 22.7498 4.81884C22.7497 5.76532 22.3736 6.67298 21.7043 7.34218C21.7043 7.34222 21.7043 7.34215 21.7043 7.34218L8.35642 20.6921C8.03766 21.0098 7.64578 21.2445 7.21517 21.3754L2.85984 22.6961C2.64373 22.7611 2.41407 22.7664 2.19523 22.7113C1.97639 22.6563 1.77652 22.5431 1.61683 22.3837C1.45714 22.2242 1.34358 22.0245 1.28821 21.8058C1.23284 21.587 1.23772 21.3574 1.30234 21.1411L1.30327 21.1381L2.62427 16.7861L2.62488 16.784C2.75698 16.3532 2.99292 15.9614 3.31195 15.6432C3.31181 15.6434 3.3121 15.6431 3.31195 15.6432L16.6577 2.2945ZM17.7182 3.35529L4.37149 16.705C4.22657 16.8495 4.11935 17.0273 4.05923 17.2229C4.05915 17.2232 4.05932 17.2227 4.05923 17.2229L2.87509 21.1241L6.7787 19.9403C6.97435 19.8808 7.15241 19.7742 7.29727 19.6299C7.29721 19.63 7.29733 19.6298 7.29727 19.6299L20.6436 6.2816C21.0316 5.89366 21.2497 5.36735 21.2498 4.81865C21.2499 4.26995 21.032 3.7437 20.644 3.35566C20.2561 2.96762 19.7299 2.74958 19.1812 2.74951C18.6325 2.74944 18.1062 2.96735 17.7182 3.35529Z"
        fill="currentColor"
      />
    </svg>
  )
}
